import { inject } from "@angular/core";
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { catchError, from, mergeMap, throwError } from "rxjs";
import { API_BASE_URL } from "./api-base";
import { AuthService } from "./auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const request = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    : req;

  if (token && request.url.startsWith(API_BASE_URL)) {
    authService.touchActivity();
  }

  return next(request).pipe(
    catchError((error: unknown) => {
      const isAuthMutation = request.url.endsWith("/auth/login") || request.url.endsWith("/auth/signup");
      if (error instanceof HttpErrorResponse && error.status === 401 && !isAuthMutation) {
        return from(authService.refreshSession()).pipe(
          mergeMap((refreshed) => {
            if (!refreshed) {
              authService.logout();
            }
            return throwError(() => error);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
